<template>
  <div>
    <BaseErrors :errors="errors"></BaseErrors>
    <form enctype="multipart/form-data"
          accept-charset="UTF-8"
          method="post">
      <div class="form-group">
        <label for="file-input" class="form-label">File</label>
        <input type="file" ref="file" class="form-control-file" name="brew-file" v-on:change="handleFileUpload()" id="file-input">
        <div class="form-text">Please select a CSV import file</div>
      </div>

      <button type="submit" :disabled="loading" v-on:click.prevent="submitFile()" class="btn btn-primary btn-sm">
        <span v-if="!loading">Import</span>
        <span v-if="loading">Uploading...</span>
      </button>
    </form>
  </div>
</template>


<script>
    import { EventBus } from '../lib/event-bus.js';
    import BaseErrors from "@/components/bits/BaseErrors";
    import { HTTP } from '../lib/http';

    export default {
        name: 'brew-records-import',
        props: {
            brewSessionId: Number
        },
        components: {
          BaseErrors
        },
        data() {
            return {
                errors: null,
                loading: false,
                file: ''
            }
        },
        methods: {
            handleFileUpload() {
                this.file = this.$refs.file.files[0];
            },
            submitFile() {
                let formData = new FormData();
                this.loading = true;
                formData.append('file', this.file);

                HTTP.post( `/brew-sessions/${this.brewSessionId}/import`,
                    formData,
                    { headers: { 'Content-Type': 'multipart/form-data' }})
                    .then(response => {
                      EventBus.$emit(`brew-session-data-changed:${this.brewSessionId}`, true)
                    })
                    .catch(err => {
                        this.errors = [err.response.data.errors];
                    })
                    .then(() => {
                        this.loading = false;
                    });
            }
        },
        beforeMount() {
        },
    }
</script>

<style scoped lang="scss">
  @import "/../assets/scss/_variablesx.scss";

</style>
